import { Component } from 'react';
import { connect } from 'react-redux';
import throttle from 'lodash-es/throttle';
import { getVisibleWidth, getVisibleHeight } from 'utils/browser';
import { setWindowSize } from './ducks';

class BrowserProvider extends Component {
  constructor() {
    super();
    this.handleResize = throttle(this.handleResize.bind(this), 1000);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.props.dispatch(setWindowSize(getVisibleWidth(), getVisibleHeight()));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.props.dispatch(setWindowSize(getVisibleWidth(), getVisibleHeight()));
  }

  render() {
    return null;
  }
}

export default connect()(BrowserProvider);



// WEBPACK FOOTER //
// ./src/common/jsx/layout/BrowserProvider/index.js